export interface EutrState {
    editingEutrElements: Array<EutrElement>;
    editingEutrElement?: EutrElement;
    editingEutrPreSupplier?: EutrPreSupplier;
}

export interface EutrDocument {
    id?: number;
    name: string;
    href: string;
}

export interface EutrPreSupplier {
    id?: number;
    name: string;
    country?: string;
    certification?: boolean;
    documents?: EutrDocument[];
    preSuppliers?: EutrPreSupplier[];

    [key: string]: undefined | string | number | boolean | EutrDocument[] | EutrPreSupplier[];
}

export interface EutrElement {
    id?: number;
    sequentialNumber: number;
    description?: string;
    volume?: number;
    weight?: number;
    kindOfWoodScientific?: string;
    kindOfWoodTrade?: string;
    countryOfOrigin?: string;
    region?: string;
    flegt?: boolean;
    cites?: boolean;
    certification?: string;
    certificateNumber?: string;
    fscClaim?: string;
    documents?: EutrDocument[];
    preSuppliers?: EutrPreSupplier[];

    [key: string]: undefined | string | number | boolean | EutrDocument[] | EutrPreSupplier[];
}

export const SET_EDITING_EUTR_ELEMENTS = "SET_EDITING_EUTR_ELEMENTS";
export const SET_EDITING_EUTR_ELEMENT = "SET_EDITING_EUTR_ELEMENT";
export const SET_EDITING_EUTR_PRE_SUPPLIER = "SET_EDITING_EUTR_PRE_SUPPLIER";

interface setEditingEutrElementsAction {
    type: typeof SET_EDITING_EUTR_ELEMENTS;
    payload: Array<EutrElement>;
}

interface setEditingEutrElementAction {
    type: typeof SET_EDITING_EUTR_ELEMENT;
    payload: EutrElement;
}

interface setEditingEutrPreSupplierAction {
    type: typeof SET_EDITING_EUTR_PRE_SUPPLIER;
    payload: EutrPreSupplier;
}

export type EutrTypes =
    setEditingEutrElementsAction
    | setEditingEutrElementAction
    | setEditingEutrPreSupplierAction;